import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { LinePlot } from "@/tools/line-chart/components/LinePlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.area_tool_name()}
        toolPath="/area-chart"
      />
      <SciHeader title={m.area_h1()} intro={m.area_intro()} />

      <LinePlot area />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.area_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.area_ex1(), m.area_ex2(), m.area_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.area_faq_q1(), a: m.area_faq_a1() },
          { q: m.area_faq_q2(), a: m.area_faq_a2() },
          { q: m.area_faq_q3(), a: m.area_faq_a3() },
          { q: m.area_faq_q4(), a: m.area_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
